import { render } from "./StaffChangePasswordModal.vue?vue&type=template&id=1e0dc25b&scoped=true"
import script from "./StaffChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./StaffChangePasswordModal.vue?vue&type=script&lang=js"

import "./StaffChangePasswordModal.vue?vue&type=style&index=0&id=1e0dc25b&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0dc25b"]])

export default __exports__